import {
  ContractType,
  Country,
  RoomCountOption,
  RoomCountRange,
} from '@immosky/types';

interface RoomCountOptions {
  buy: RoomCountOption[];
  rent: RoomCountOption[];
}

export const INITIAL_ROOM_COUNT_RANGE: RoomCountRange = {
  min: {
    text: '',
    value: 0,
  },
  max: {
    text: '',
    value: 0,
  },
};

const countrySpecificRoomCountOptions: { [country: string]: RoomCountOptions } =
  {
    ['CH']: {
      buy: [
        {
          text: '1',
          value: 1,
        },
        {
          text: '1.5',
          value: 1.5,
        },
        {
          text: '2',
          value: 2,
        },
        {
          text: '2.5',
          value: 2.5,
        },
        {
          text: '3',
          value: 3,
        },
        {
          text: '3.5',
          value: 3.5,
        },
        {
          text: '4',
          value: 4,
        },
        {
          text: '4.5',
          value: 4.5,
        },
        {
          text: '5',
          value: 5,
        },
        {
          text: '5.5',
          value: 5.5,
        },
        {
          text: '6',
          value: 6,
        },
        {
          text: '6.5',
          value: 6.5,
        },
        {
          text: '7+',
          value: Infinity,
        },
      ],
      rent: [
        {
          text: '1',
          value: 1,
        },
        {
          text: '1.5',
          value: 1.5,
        },
        {
          text: '2',
          value: 2,
        },
        {
          text: '2.5',
          value: 2.5,
        },
        {
          text: '3',
          value: 3,
        },
        {
          text: '3.5',
          value: 3.5,
        },
        {
          text: '4',
          value: 4,
        },
        {
          text: '4.5',
          value: 4.5,
        },
        {
          text: '5',
          value: 5,
        },
        {
          text: '5.5',
          value: 5.5,
        },
        {
          text: '6+',
          value: Infinity,
        },
      ],
    },
    ['FR']: {
      buy: [
        {
          text: '1',
          value: 1,
        },
        {
          text: '1.5',
          value: 1.5,
        },
        {
          text: '2',
          value: 2,
        },
        {
          text: '2.5',
          value: 2.5,
        },
        {
          text: '3',
          value: 3,
        },
        {
          text: '3.5',
          value: 3.5,
        },
        {
          text: '4',
          value: 4,
        },
        {
          text: '4.5',
          value: 4.5,
        },
        {
          text: '5',
          value: 5,
        },
        {
          text: '5.5',
          value: 5.5,
        },
        {
          text: '6',
          value: 6,
        },
        {
          text: '6.5',
          value: 6.5,
        },
        {
          text: '7',
          value: 7,
        },
        {
          text: '7+',
          value: Infinity,
        },
      ],
      rent: [
        {
          text: '1',
          value: 1,
        },
        {
          text: '1.5',
          value: 1.5,
        },
        {
          text: '2',
          value: 2,
        },
        {
          text: '2.5',
          value: 2.5,
        },
        {
          text: '3',
          value: 3,
        },
        {
          text: '3.5',
          value: 3.5,
        },
        {
          text: '4',
          value: 4,
        },
        {
          text: '4.5',
          value: 4.5,
        },
        {
          text: '5',
          value: 5,
        },
        {
          text: '5+',
          value: Infinity,
        },
      ],
    },
  };

export function getRoomCountOptionsForContractType(
  countries: Country[],
  contractType: ContractType
): RoomCountOption[] {
  let roomCountOptions = countrySpecificRoomCountOptions['CH'];

  if (countries.indexOf('FR') > -1) {
    roomCountOptions = countrySpecificRoomCountOptions['FR'];
  }

  switch (contractType) {
    case 'buy':
      return roomCountOptions.buy;
    case 'rent':
      return roomCountOptions.rent;
  }
}
